import { render, staticRenderFns } from "./ArtifactManage.vue?vue&type=template&id=77c09dc2&scoped=true&"
import script from "./ArtifactManage.vue?vue&type=script&lang=js&"
export * from "./ArtifactManage.vue?vue&type=script&lang=js&"
import style0 from "./ArtifactManage.vue?vue&type=style&index=0&id=77c09dc2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77c09dc2",
  null
  
)

export default component.exports